import { Component, Input } from '@angular/core';
import {
  CustomerAddress,
  CustomerProfile,
} from '../../types/CustomerSocialLogin';
import { LocationService } from 'src/app/public/location.service';
import { Router } from '@angular/router';
import { Utils } from 'src/app/stores/utils/Utils';

@Component({
  selector: 'app-profile-addresses',
  templateUrl: './profile-addresses.component.html',
  styleUrl: './profile-addresses.component.scss',
})
export class ProfileAddressesComponent {
  @Input() customerProfile: CustomerProfile;

  constructor(
    private locationService: LocationService,
    private router: Router,
  ) {}

  formatAddress(address: CustomerAddress): string {
    return Utils.formatAddress(address);
  }

  onAddAddress() {
    this.router.navigateByUrl(this.locationService.base_url('edit-address'));
  }

  onEditAddress(addressId: string) {
    this.router.navigateByUrl(
      this.locationService.base_url(`edit-address/${addressId}`),
    );
  }
}
